export default __webpack_public_path__ + "static/ak-cached/24h/media/acc_phone.14959a65.png";